module.exports = __webpack_public_path__ + "public/images/learn_together.a89565f27bcea56123091e501c2c619f.png";